// extracted by mini-css-extract-plugin
module.exports = {"modal":"bonus_modal_modal__G2mzU","closeModal":"bonus_modal_closeModal__1v9FX","container":"bonus_modal_container__2Mzbb"};